export default {
  "storage": "cookies",
  "debug": false,
  "cookieOptions": {}
}